module.exports = __webpack_public_path__ + "img/switched-off.fec9ff81.svg";